import ipfs from 'decentralized/Ipfs.js';
import {GUILD, USER, NONE} from 'constants/encryption-levels.js';
import {SOUND} from 'constants/encrypted-content-types.js';
import Tone from 'tone';
const bufferToArrayBuffer = require('buffer-to-arraybuffer');

let testHash = 'QmcfgECwvezrtmVGMywi6epaRMa8NE748V6UiGaBRALeQW';

const PUBLIC = 1;
const NO_ACCESS = 2;

class EncryptedIpfs {
    constructor(store, guilds, encryption, crypto) {
        this.store = store; 
        this.guilds = guilds; 
        this.encryption = encryption ;
        this.crypto = crypto;
    }

    // needs to know whether to use
    // guild-level encryption, user-level encrytpion
    // or no encryption
    async addJson(json, contentType=110, name, encryptionLevel=GUILD, guildId) {
        if (encryptionLevel===NONE) {
            return await ipfs.addJson(json);
        }
        // encrypt as guild
        // todo: check encryption level
        let keyData = await this.guilds.getGuildKey(guildId);
        let publicKey = keyData.rawPublicKey;

        let encryptedContent = await this.crypto.encryptRawContent(
            JSON.stringify(json), name, publicKey);
        let hash = await ipfs.addJson(encryptedContent.encryptedContent);

        this.encryption.newEncryptedContent(
            hash,
            encryptedContent.encryptedName,
            encryptedContent.encryptedContentKey,
            contentType,
            keyData.publicKey);
                                            
        return hash;
    }

    async addSound(sound, encryptionLevel=GUILD, guild, contentKey) {
        if (encryptionLevel===NONE) {
            return await ipfs.addBlob(sound);
        }

        let keyData = await this.guilds.getGuildKey(guild);
        let publicKey = keyData.rawPublicKey;

        contentKey.encryptKey(publicKey);

        let encryptedContent = await this.crypto.encryptRawContent(
            sound, '' , publicKey, true, contentKey);

        return await ipfs.addBytesArray(encryptedContent.encryptedContent)
    }

    async addBlob(blob, encryptionLevel=GUILD, guildId) {
        if (encryptionLevel===NONE) {
            return await ipfs.addBlob(blob);
        }

        let keyData = await this.guilds.getGuildKey();
        let publicKey = keyData.rawPublicKey;

        let encryptedContent = await this.crypto.encryptRawContent(
            blob, '' , publicKey, true);

        let hash = await ipfs.addJson(encryptedContent.encryptedContent)
        this.encryption.newEncryptedContent(
            hash,
            encryptedContent.encryptedName,
            encryptedContent.encryptedContentKey,
            SOUND,
            keyData.publicKey);

        return hash;
    }

    async getEncryptedContentMetadata(hash, contentType, guildId) {
        let dateA = new Date().getTime();
        if (guildId === undefined) {
            // we aren't passed a guild, so we must find out what
            // guild the data is a part of (if any)
            guildId = await this.guilds.getContentGuildId(hash, contentType);
        }
        if (guildId === 0) {
            // it's not encrypted b/c its not part of a guild
            // return PUBLIC;
            return PUBLIC;
        }

        let hasAccess = await this.guilds.hasAccessTo(guildId);
        if (!hasAccess) {
            return NO_ACCESS;
        }

        let dateB = new Date().getTime();
        let timeAB = dateB - dateA;

        let guildKey = await this.guilds.getGuildKey(guildId);
        let dateC = new Date().getTime();
        let timeBC = dateC - dateB;
        let encryptedContent = undefined;
        if (guildKey) {
            encryptedContent = await this.encryption.getEncryptedContent(hash, guildKey.privateKey);
        }

        if (encryptedContent === undefined) {
            encryptedContent = await this.encryption.getEncryptedContent(hash);
        }

        let dateD = new Date().getTime();
        let timeDC = dateD - dateC;

        return encryptedContent;
    }

    // infers encryption level by checking blockchain
    async getJson(hash=testHash, contentType, sleepTime) {
        let encryptedContent = await this.getEncryptedContentMetadata(hash, contentType);
        // check whether encrypted content exists
        if (encryptedContent === PUBLIC || encryptedContent === undefined) {
            // if it's not encrypted by guild key or user key, 
            // then it is simply not encrypted.
            return await ipfs.getJson(hash, sleepTime);
        } else if (encryptedContent === NO_ACCESS) {
            return {};
        }

        // otherwise, decrypt the content using the retrieved content key
        let decrypted = await this.crypto.fetchAndDecrypt(hash, encryptedContent, undefined, sleepTime);
        return JSON.parse(decrypted);
    }

    async getSound(hash='QmYPK9KSRnm5LRvZZkrhLD9HJNVoQpbPBkokF1gt8FwZv8', guildId) {
        let dateA = new Date();
        let encryptedContent = await this.getEncryptedContentMetadata(hash, SOUND, guildId);
        let dateC = new Date();
        let timeCA = dateC.getTime() - dateA.getTime();
        // check whether encrypted content exists
        if (encryptedContent === PUBLIC || encryptedContent === undefined) {
            // if it's not encrypted by guild key or user key, 
            // then it is simply not encrypted.
            return await ipfs.getSound(hash);
        } else if (encryptedContent === NO_ACCESS) {
            return undefined;
        }

        let decrypted = await this.crypto.fetchAndDecrypt(hash, encryptedContent, true);
        let dateB = new Date();
        let time = dateB.getTime() - dateA.getTime();
        return decrypted;
    }

    get guildId() {
        let guild = this.store.getState().guilds.selectedGuild;
        return guild ? guild.guildId : 0;
    }
}

export default EncryptedIpfs;
